import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import Settings from "./settings";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<Settings />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
